import { getRandomInt } from '~/bootcamp/Activities/Fractions/Fractions.utils'
import { rangeBetween, shuffle } from '~/utils'
import {
  equationPartsToString,
  simplifyEquationParts,
  EquationPartsModel,
  equationStringToSortedParsedString,
} from '~/bootcamp/Activities/Algebra/Algebra.utils'

const VARIABLES = ['a', 'b', 'c', 'x', 'y', 'z', 'ab', 'ac', 'bc', 'ax', 'by', 'cz', 'xy', 'yz']

const RANGE_DATA: RangeDataModel = {
  1: {
    minTerms: 4,
    maxTerms: 10,
    maxVariableIndex: 5,
    minCoefficient: 1,
    maxCoefficient: 5,
    minConstant: 1,
    maxConstant: 10,
    maxHistoryLength: 7,
  },
  2: {
    minTerms: 4,
    maxTerms: 10,
    maxVariableIndex: VARIABLES.length - 1,
    minCoefficient: 1,
    maxCoefficient: 8,
    minConstant: -10,
    maxConstant: 10,
    maxHistoryLength: 7,
  },
  3: {
    minTerms: 4,
    maxTerms: 10,
    maxVariableIndex: VARIABLES.length - 1,
    minCoefficient: 1,
    maxCoefficient: 5,
    minConstant: -10,
    maxConstant: 10,
    maxHistoryLength: 7,
  },
}

interface RangeDataModel {
  [key: number]: RangeItemModel
}

interface RangeItemModel {
  minTerms: number
  maxTerms: number
  maxVariableIndex: number
  minCoefficient: number
  maxCoefficient: number
  minConstant: number
  maxConstant: number
  maxHistoryLength: number
}

export enum TermsType {
  SIGN,
  INTEGER,
  COEFFICIENT,
  VARIABLE,
}

export interface ActivityDataModel {
  equationString: string
  originalEquationString: string
  equationParts: EquationPartsModel[]
  maxHistoryLength: number
}

/**
 * generates a algebraic equation
 * @param difficultyLevel difficulty level of the activity
 * @param taskHistory equations to excludes
 * @returns generated equation in parts and equation string
 */
export function generateUnlikeInputActivityData(difficultyLevel: number, taskHistory: string[]): ActivityDataModel {
  const range = RANGE_DATA[difficultyLevel]
  const totalTerms = getRandomInt(range.minTerms, range.maxTerms)
  let equationParts: EquationPartsModel[] = []
  const variableIndexes = [...shuffle(rangeBetween(0, range.maxVariableIndex)).slice(0, 3), -1]
  // eslint-disable-next-line
  for (let i = 0; i < totalTerms; i++) {
    equationParts[i] = {
      integer:
        i % 4 === 3
          ? getRandomInt(range.minCoefficient, range.maxConstant, [0])
          : getRandomInt(range.minCoefficient, range.maxCoefficient, [0]),
      variable: VARIABLES[variableIndexes[i % 4]],
    }
  }
  equationParts = shuffle(equationParts)
  const originalEquationString = equationPartsToString(equationParts)
  const simplifiedEquationParts = simplifyEquationParts(equationParts)
  const equationString = equationPartsToString(simplifiedEquationParts)
  if (taskHistory.includes(equationString)) return generateUnlikeInputActivityData(difficultyLevel, taskHistory)
  return { equationParts, equationString, originalEquationString, maxHistoryLength: range.maxHistoryLength }
}

export function checkAnswer(userAnswerString: string, equationString: string): boolean {
  return equationString === equationStringToSortedParsedString(userAnswerString)
}
